import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/components/BlogPage/blog.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["HomeSubscribe"] */ "/vercel/path0/shared/components/HomeSubscribe.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/components/RelatedPostCard.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/components/RelatedPosts.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/shared/components/ShareButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/shared/components/TableOfContent.tsx");
